module.exports = __webpack_public_path__ + "img/logoJust.1daa42b8.svg";